import api from './api';

const KEY = 'pending_plan_id';

export const setPendingPlan = (planId) => sessionStorage.setItem(KEY, JSON.stringify({ planId, at: Date.now() }));
const MAX_AGE = 30 * 60 * 1000;

export const startCheckout = async (planId) => {
  const { data } = await api.post('/payments/checkout', { plan_id: planId, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};

// After sign-up / sign-in: continue to payment for the plan the visitor picked. Returns true if redirecting.
export const resumePendingCheckout = async () => {
  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }
  sessionStorage.removeItem(KEY);
  if (!saved?.planId || Date.now() - saved.at > MAX_AGE) return false;
  const { planId } = saved;
  try {
    await startCheckout(planId);
    return true;
  } catch (e) {
    return false;
  }
};
